import { Component } from "@angular/core";
import { MatTabsModule } from "@angular/material/tabs";
import { FeedConnectionsComponent } from "../feed-connections/feed-connections.component";
import { FeedListComponent } from "../feed-list/feed-list.component";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: 'app-manage-feeds',
  standalone: true,
  imports: [
    MatTabsModule,
    FeedConnectionsComponent,
    FeedListComponent
  ],
  templateUrl: './manage-feeds.component.html'
})
export class ManageFeedsComponent {

  activeTabIndex = 0;

  constructor(private route: ActivatedRoute) { }

  ngOnInit() {
    this.route.queryParamMap.subscribe(params => {
      const tab = params.get('tab');
      if (tab === 'feeds') {
        this.activeTabIndex = 1;
      } else {
        this.activeTabIndex = 0;
      }
    });
  }



}
